import React, { Component } from 'react';
import firebase from 'firebase';
import moment from 'moment';
import waterfall from 'async/waterfall';
import parallel from 'async/parallel';
import { Button } from 'semantic-ui-react';
import ToUserCard from './ToUserCard.js';
import FromUserCard from './FromUserCard.js';
import './App.css';
class App extends Component {
  constructor(props) {
      super(props);
      this.state = {
        user: null,
        toTransactions: {},
        fromTransactions: {}
      }
      firebase.initializeApp({
        apiKey: "AIzaSyBXkafZzDcuU5Ni83qKv4MPWwml8QQdSKY",
        authDomain: "elle-men.firebaseapp.com",
        databaseURL: "https://elle-men.firebaseio.com",
        projectId: "elle-men",
        storageBucket: "elle-men.appspot.com",
        messagingSenderId: "412969331369"
      });
      firebase.auth().useDeviceLanguage();
      this.provider = new firebase.auth.GoogleAuthProvider();
      this.provider.addScope('email');
      this.usersRef = null;
      this.transactionsRef = null;
    }

  componentDidMount() {
    var self = this;
    firebase.auth().onAuthStateChanged(user => {
      if(user) {
        waterfall([
          updateMyProfileDoneCallback => {
            self.usersRef = firebase.database().ref('/users');
            self.transactionsRef = firebase.database().ref('/transactions');
            self.usersRef.child('/'+user.uid).update({
              displayName: user.displayName,
              email: user.email,
              photoURL : user.photoURL
            }).then(() => {
              return updateMyProfileDoneCallback();
            }).catch(err => {
              return updateMyProfileDoneCallback(err);
            })
          },
          getMyProfileDoneCallback => {
            self.usersRef.child('/'+user.uid).once('value').then(userSnapshot => {
              if(!userSnapshot.val().verified) {
                firebase.auth().signOut();
                throw new Error('用戶未啟用');
              } else {
                return userSnapshot.val();
              }
            }).then(myProfile => {
              return getMyProfileDoneCallback(null, myProfile);
            }).catch(err => {
              return getMyProfileDoneCallback(err);
            })
          },
          (myProfile, handleTransactionDoneCallback) => {
            parallel([
              handleToTransactionDoneCallback => {
                self.usersRef.child('/'+user.uid+'/toTransactions').on('child_added', data => {
                  const transactionId = data.key;
                  self.transactionsRef.child('/'+transactionId).once('value').then(transactionSnapshot => {
                    const transaction = transactionSnapshot.val();
                    if(transaction.status === 'verified' && moment().diff(moment(transaction.createDate), 'days') > 14) {
                      return;
                    } else {
                      self.usersRef.child('/'+transaction.toUser).once('value').then(userSnapshot => {
                        const user = userSnapshot.val();
                        self.transactionsRef.child('/'+transactionId).on('child_changed', data => {
                          if(self.state.toTransactions[transactionId][data.key] !== undefined) {
                            self.state.toTransactions[transactionId][data.key] = data.val();
                            self.forceUpdate();
                          }
                        });
                        self.state.toTransactions[transactionId] = {
                          alipay: user.alipay,
                          alipayName: user.alipayName,
                          displayName: user.displayName,
                          photoURL: user.photoURL,
                          amount: transaction.amount,
                          status: transaction.status,
                          createDate: transaction.createDate
                        }
                        self.forceUpdate();
                        return;
                      }).catch(err => {
                        throw new Error(err);
                      })
                    }
                  }).catch(err => {
                    throw new Error(err);
                  })
                });
                return handleToTransactionDoneCallback();
              },
              handleFromTransactionDoneCallback => {
                self.usersRef.child('/'+user.uid+'/fromTransactions').on('child_added', data => {
                  const transactionId = data.key;
                  self.transactionsRef.child('/'+transactionId).once('value').then(transactionSnapshot => {
                    const transaction = transactionSnapshot.val();
                    if(transaction.status === 'verified' && moment().diff(moment(transaction.createDate), 'days') > 14) {
                      return;
                    } else {
                      self.usersRef.child('/'+transaction.fromUser).once('value').then(userSnapshot => {
                        const user = userSnapshot.val();
                        self.transactionsRef.child('/'+transactionId).on('child_changed', data => {
                          if(self.state.fromTransactions[transactionId][data.key] !== undefined) {
                            self.state.fromTransactions[transactionId][data.key] = data.val();
                            self.forceUpdate();
                          }
                        });
                        self.state.fromTransactions[transactionId] = {
                          alipayName: user.alipayName,
                          displayName: user.displayName,
                          photoURL: user.photoURL,
                          amount: transaction.amount,
                          status: transaction.status,
                          createDate: transaction.createDate
                        }
                        self.forceUpdate();
                        return;
                      }).catch(err => {
                        throw new Error(err);
                      })
                    }
                  }).catch(err => {
                    throw new Error(err);
                  })
                });
                return handleFromTransactionDoneCallback();
              },
            ], err => {
              return handleTransactionDoneCallback(err);
            })
          }
        ], (err) => {
          if(err) {
            alert(err);
          }
        })
      }
      self.setState({
        user: user
      })
    });
  }
  signIn = () => {
    firebase.auth().signInWithPopup(this.provider).then(result => {
    }).catch(error => {
    });
  }
  signOut = () => {
    firebase.auth().signOut().then(() => {
    }).catch(error => {
    });
  }
  changeTransactionStatus = (transactionId, status) => {
    this.transactionsRef.child('/'+transactionId).update({
      status: status
    })
  }
  render() {
    var self = this;
    return (
      <div className="dialog fourteen wide column centered">
        {(this.state.user) ?
          <Button onClick={this.signOut}>登出</Button>
        :
          <button onClick={this.signIn} className="ui google plus button"><i className="google icon"></i>登入</button>
        }
        {(this.state.user !== null) ?
          <div className="ui two column grid">
            <div className="column">
              <div className="ui horizontal divider">付款</div>
            </div>
            <div className="column">
              <div className="ui horizontal divider">收款</div>
            </div>
            <div className="column">
              <div className="ui two column grid">
                {Object.keys(this.state.toTransactions).map((toTransactionId, index) => {
                  return (
                    <div key={index} className="column">
                      <ToUserCard
                        transactionId={toTransactionId}
                        imageSrc={self.state.toTransactions[toTransactionId].photoURL}
                        header={self.state.toTransactions[toTransactionId].displayName}
                        amount={"$"+self.state.toTransactions[toTransactionId].amount}
                        method="支付寶HK"
                        alipay={self.state.toTransactions[toTransactionId].alipay}
                        alipayName={self.state.toTransactions[toTransactionId].alipayName}
                        status={self.state.toTransactions[toTransactionId].status}
                        createDate={self.state.toTransactions[toTransactionId].createDate}
                        onClickScanPayment={self.changeTransactionStatus.bind(this, toTransactionId, 'scan')}
                        onClickConfirmPayment={self.changeTransactionStatus.bind(this, toTransactionId, 'paid')}
                        onClickCancelPayment={self.changeTransactionStatus.bind(this, toTransactionId, 'wait')} />
                    </div>
                  )
                })

                }
              </div>
            </div>
            <div className="column">
              <div className="ui two column grid">
                {Object.keys(this.state.fromTransactions).map((fromTransactionId, index) => {
                  return (
                    <div key={index} className="column">
                      <FromUserCard
                        imageSrc={self.state.fromTransactions[fromTransactionId].photoURL}
                        header={self.state.fromTransactions[fromTransactionId].displayName}
                        amount={"$"+self.state.fromTransactions[fromTransactionId].amount}
                        method="支付寶HK"
                        alipayName={self.state.fromTransactions[fromTransactionId].alipayName}
                        status={self.state.fromTransactions[fromTransactionId].status}
                        createDate={self.state.fromTransactions[fromTransactionId].createDate}
                        onClickConfirmVerify={self.changeTransactionStatus.bind(this, fromTransactionId, 'verified')} />
                    </div>
                  )
                })
                }
              </div>
            </div>
          </div>
        :
          null
        }
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js